export const environment = {
    production: false,
    ApiUrl :"https://sams-api-test1.azure.chevron.com/api/v1/",
    calConfig: {
      "autoSignIn": true,
      "popupForLogin": false,
      "cacheLocation": "localStorage",
      "instance": "https://login.microsoftonline.com/",
      "tenantId": "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
      "clientId":"f94c3d8e-19b5-428a-b89d-eb4d7aa14ff7",
      "redirectUri": "https://sams-ui-test1.azure.chevron.com",
      "oidcScopes": ["openid", "profile", "User.Read","offline_access"],
      "graphScopes": ["User.Read", "User.Read.All"],
      "scopes": ['https://sams-test.azure.chevron.com/user_impersonation'],
      "name": 'Test1'
    }
  };